import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OwnersComponent extends Component {
  static readonly TYPE_ID: string = '58e30976c1374c8b9e95879d6d18bffb';

  constructor(
    public readonly owners: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return OwnersComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): OwnersComponent {
    return new OwnersComponent(
        MapUtils.getList<string>(map, 'owners', (v) => v as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'owners': this.owners,
    };
  }

  clone(): this {
    return new OwnersComponent(
        this.owners,
    ) as this;
  }

  isSame(other: OwnersComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.owners === this.owners;
  }
}

export class OwnersComponentBuilder extends DataModelBuilder<OwnersComponent> {
  build(context: SerializationContext, map: SerializedData): OwnersComponent {
    return OwnersComponent.fromMap(context, map);
  }
}
